export { default as create } from "./Create";
export { default as edit } from "./Edit";
export { default as list } from "./List";
export { default as show } from "./Show";
export const name = "media-center/admin/gallery";
export const options = {
  label: "Gallery/Albums",
};
